import Backend from 'App/Dataman-Backend';

const {
  apiUrlLogin,
  apiUrlUser,
  apiUrlUsers,
  apiUrlUsersStaffStatistics,
  apiUrlRoles,
  apiUrlUserGroups,
  apiUrlUserFilters,
  apiUrlUserBookmarks,
  apiUrlChangePassword,
  apiUrlAccessLog,
  resetPasswordRequest,
  resetPasswordReset,
  staffStats,
  staffStatsItem,
  apiUrlSuffix,
} = Backend.config;

export const USERS_PATHS = {
  login: apiUrlLogin,
  user: apiUrlUser,
  users: apiUrlUsers,
  staffStatistics: apiUrlUsersStaffStatistics,
  roles: apiUrlRoles,
  userGroups: apiUrlUserGroups,
  userFilters: apiUrlUserFilters,
  userBookmarks: apiUrlUserBookmarks,
  changePassword: apiUrlChangePassword,
  accessLog: apiUrlAccessLog,
  resetPasswordRequest,
  resetPasswordReset,
  staffStats,
  staffStatsItem,
  suffix: apiUrlSuffix,
};
